import { Select } from 'antd';
import React from 'react';

interface SelectFilterProps {
  defaultValue?: string;
  dataOptions?: { label: string; value: string }[];
  showSearch?: boolean;
  allowClear?: boolean;
  isLoading?: boolean;
  handleChange: (value: any) => void;
  className?: string | undefined;
}

const SelectFilter: React.FC<SelectFilterProps> = ({
  allowClear,
  defaultValue,
  dataOptions,
  showSearch,
  className = 'w-64',
  handleChange,
  isLoading,
}) => {
  const filterOption = (
    input: string,
    option?: {
      label: string;
      value: string;
    },
  ) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <Select
      onChange={handleChange}
      allowClear={allowClear}
      showSearch={showSearch}
      className={className}
      loading={isLoading}
      value={defaultValue}
      placeholder="Select"
      filterOption={filterOption}
      options={dataOptions}
    />
  );
};

export default SelectFilter;
